import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import {Modal, Form, Input, Radio, Space, Button, Select} from "antd"
import axios from "axios"
import { useRef, useEffect } from "react"

const backend = process.env.REACT_APP_BACKEND;

export default function EditWordModal ({editModal, modalHandler, pos, getSourceData, sourceData, indexNumber, setIndexNumber, tableParams, setTableParams}) {
  const ref = useRef()
  const pageChangeRef = useRef(false)

  //초기화 버튼 함수
  const clearHandler = () => {
    ref.current.resetFields()
  }

  //이전 버튼 클릭 시 데이터로 이동하는 함수
  const preEditData = () => {
    const {current, pageSize} = tableParams.pagination
    if(indexNumber > 0) {
      setIndexNumber(indexNumber-1)
    } else {
      if(current !== 1) {
        modalHandler("tableParams",{
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            current: current-1
          }
        })
        setIndexNumber(pageSize-1)
        pageChangeRef.current = true
      }
    }
  }
  
  //다음 버튼 클릭 시 데이터로 이동하는 함수
  const nextEditData = () => {
    const {current, pageSize, total} = tableParams.pagination
    const maxPage = total%pageSize === 0 ? total/pageSize : parseInt(total/pageSize+1)
    const remainder = total%pageSize

    if(indexNumber < pageSize -1) {
      if(current !== maxPage) {
        setIndexNumber(indexNumber+1)
      } else if(indexNumber < remainder -1) {
        setIndexNumber(indexNumber+1)
      }
    } else {
      if(current !== maxPage) {
        modalHandler("tableParams",{
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            current: current+1
          }
        })
        setIndexNumber(0)
        pageChangeRef.current = true // index가 바뀌고 렌더링이 되며 팝업데이터가 바뀌지만 다시 sourceData가 바뀌며 재랜더링이 된다. 이를 방지하기 위함.
      }
    }
  }

  //단어 등록 함수
  const editHandler = async () => {
    try {
      await ref.current.validateFields()
      const values = await ref.current.getFieldsValue()

      axios.patch(`${backend}/contents/new_word/word/list`,{values})
        .then(res => {
          getSourceData()
          Modal.success({
            title: "수정 완료",
            content: "정상적으로 수정 되었습니다.",
            okText: "확인",
            afterClose: ()=>modalHandler("editModal", false)
          })
        })
        .catch(err => {
          console.log(err)
          if(err.response?.status === 500) {
            Modal.error({
              title: "수정 실패",
              content: err.response.data.message,
              okText:"확인",
              cancelText:"취소"
            })
          }
        })
    } catch (err) {
      console.log(err)
    }
  }

  //취소 버튼 함수
  const cancelHandler = () => {
    modalHandler("editModal", false)
    setIndexNumber(null)
  }

  useEffect(()=>{
    if(indexNumber >= 0 && ref.current && !pageChangeRef.current) {
      ref.current.resetFields()
    }
    pageChangeRef.current = false // indexNumber와 page가 동시에 바뀌는 경우 두번의 reset이 진행됨. 이를 막기 위한 임시 조치
  },[indexNumber, sourceData])

  return (
    <Modal 
      open={editModal}
      destroyOnClose = {true}
      title = "단어 수정"
      onCancel={()=>modalHandler("editModal", false)}
      maskClosable = {false}
      footer = {
        <Space style={{width:"100%", justifyContent:"space-between"}}>
          <Button onClick={clearHandler}>내용 초기화</Button>
          <Space>
            <Button onClick={preEditData}><CheckOutlined/>이전</Button>
            <Button type="primary" onClick={editHandler}><CheckOutlined/>수정</Button>
            <Button onClick={nextEditData}><CheckOutlined/>다음</Button>
            <Button onClick={cancelHandler}><CloseOutlined/>취소</Button>
          </Space>
        </Space>
      }
    >
      <Form 
        layout="vertical" 
        ref={ref}
        initialValues={sourceData[indexNumber]}
      >

        <Form.Item
          hidden={true}
          name="id"
        ><Input/></Form.Item>

        <Form.Item
          name="word"
          label="단어"
          rules={[
            {required: true, message:"필수 입력값입니다."}
          ]}
        >
          <Input></Input>
        </Form.Item>

        <Form.Item
          name="ContentSettingPartsOfSpeechMaster_code"
          label="품사"
          rules={[
            {required: true, message:"필수 입력값입니다."}
          ]}
        >
          <Select options = {pos} />
        </Form.Item>

        <Form.Item 
          name="cefr_evp"
          label="CEFR Level (EVP)"
          rules={[
            {required: true, message:"필수 입력값입니다."}
          ]}
        >
          <Radio.Group>
            <Radio value={"A0"}>A0</Radio>
            <Radio value={"A1"}>A1</Radio>
            <Radio value={"A2"}>A2</Radio>
            <Radio value={"B1"}>B1</Radio>
            <Radio value={"B2"}>B2</Radio>
            <Radio value={"C1"}>C1</Radio>
            <Radio value={"C2"}>C2</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item 
          name="derivative"
          label="파생어 (여러 개일 경우 콤바 ‘,’ 로 구분하여 입력)"

        >
          <Input></Input>
        </Form.Item>
        
      </Form>
    </Modal>
  )
}